var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Dialog as MuiDialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';
import { useTheme } from '@mui/material/styles';
var Dialog = function (_a) {
    var className = _a.className, open = _a.open, onClose = _a.onClose, title = _a.title, style = _a.style, actions = _a.actions, children = _a.children;
    var theme = useTheme();
    return (React.createElement(MuiDialog, { className: className, open: open, keepMounted: true, style: __assign({ zIndex: theme.zIndex.modal + 1 }, style), onClose: onClose, "aria-labelledby": "alert-dialog-slide-title", "aria-describedby": "alert-dialog-slide-description" },
        title && (React.createElement(DialogTitle, { id: "alert-dialog-slide-title" }, title)),
        React.createElement(DialogContent, null,
            React.createElement(DialogContentText, { id: "alert-dialog-slide-description", component: typeof children === 'string' ? 'p' : 'div' }, children)),
        actions && React.createElement(DialogActions, null, actions)));
};
export default Dialog;
